// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import {history} from "../configs/history";
import {withRouter} from 'react-router-dom';

//Import styles
import "../assets/styles/containerStyles/adminLayout.scss";

//Import components
import {LeftSideMenu} from "../components/navbars/LeftSideMenu";
import {MainHeader} from "../components/headerViews/mainHeader";
import {Footer} from "./Footer";
import {LoadingOutlined} from '@ant-design/icons';
// Import utils
import {mapStateToProps} from "../redux/mapStateToProps";
import {
    ToggleLeftSideMenu,
    TokenValidation,
    GetCategories,
    GetMedia,
    SetRoutes,
    GetTrainers,
    GetWorkoutSections,
    GetGroupWorkouts,
    GetArticles,
    GetEvents, GetServices,
} from "../redux/actions";
import {LogOut} from "../redux/actions";
import {GET_LIMITS} from "../constants/constsTypes";


class AdminLayout extends Component {
    state = {
        isMounted: false,
    };

    async componentDidMount() {
        let redirectLoginPage = false;
        const {location} = this.props;
        if (!this.props.isLoggedIn) {
            redirectLoginPage = true;
        } else {
            // if (!socketNotificationConnection._instance) {
            //     socketNotificationConnection.connectToSocket();
            // }
            await this.props.TokenValidation().then(async () => {
                // if (!socketNotificationConnection._instance) {
                //     socketNotificationConnection.connectToSocket();
                // }
            }).catch(() => {
                redirectLoginPage = true;
            });
        }
        if (redirectLoginPage) {
            this.props.LogOut();
        } else {
            !location.pathname.startsWith('/media') && this.props.GetMedia();
            this.props.GetCategories();
            this.props.GetTrainers();
            this.props.GetGroupWorkouts();
            this.props.GetWorkoutSections();
            this.props.GetArticles({
                offset:0,
                limit: GET_LIMITS,
            })
            this.props.GetEvents({
                offset:0,
                limit: GET_LIMITS,
            })
            this.props.GetServices()
            if (location && location.pathname.includes('moderators') && !this.props.isAdmin) {
                // console.log(location.pathname,"404")
                history.push('/404');
            }
            this.setState({
                isMounted: true,
            })

            // history.listen((location, action) => {
            //
            //     const {routesList} = this.props
            //     const path = location.pathname.slice(1)
            //     if (path === "login") {
            //         this.props.SetRoutes([])
            //         return
            //     }
            //     if (action === "POP" && routesList.length === 1) {
            //         if (path.split("/").length !== 1) {
            //             history.push("/" + routesList[0]?.path)
            //         }
            //     }
            //     if (path.split("/").length === 1) {
            //         // Object.keys(ACCESS_PAGES).includes(path)
            //         if (path !== routesList[routesList.length - 1]?.path) {
            //             console.log(path,'path')
            //             this.props.SetRoutes([{
            //                 path: path,
            //                 name: ACCESS_PAGES[path]?.name
            //             }])
            //         }
            //     } else {
            //         const pathInRoutesList = routesList.find(item => item.path === path)
            //         // console.log("routesList", routesList);
            //         if (pathInRoutesList) {
            //             let newRoutesList = routesList.slice(0, routesList.indexOf(pathInRoutesList) + 1)
            //             // console.log("newRoutesList", newRoutesList)
            //             this.props.SetRoutes(newRoutesList)
            //         } else {
            //             this.props.SetRoutes([...routesList, {
            //                 path: path,
            //                 name: ""
            //             }])
            //         }
            //     }
            // });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {location} = this.props;
        if (location?.pathname !== prevProps?.location?.pathname) {

            window.scrollTo(0, 0);
        }
        if (location && location.pathname.includes('moderators') && !this.props.isAdmin) {
            history.push('/404');
        }
    }


    render() {
        const {isMounted} = this.state;
        const {
            children, leftSideMenuOpen, ToggleLeftSideMenu, LogOut, isAdmin, location,
            accessPages, user,
        } = this.props;
        const spinIcon = <LoadingOutlined style={{fontSize: 54, color: "#1F3A62"}}/>;
        return isMounted ? <div className="admin-layout">
                <MainHeader toggleMenu={ToggleLeftSideMenu}
                            leftSideMenuOpen={leftSideMenuOpen}
                            isAdmin={isAdmin}
                            user={user}
                            LogOut={LogOut}/>
                <LeftSideMenu toggleMenu={ToggleLeftSideMenu}
                              leftSideMenuOpen={leftSideMenuOpen}
                              isAdmin={isAdmin}
                              accessPages={accessPages}
                              path={location && location.pathname}/>

                {children}
                <Footer leftSideMenuOpen={leftSideMenuOpen}/>
            </div> :
            <div className={'loading'}>
                {spinIcon}
            </div>
    }
}

const mapDispatchToProps = {
    ToggleLeftSideMenu,
    LogOut,
    TokenValidation,
    GetCategories,
    GetMedia,
    SetRoutes,
    GetTrainers,
    GetGroupWorkouts,
    GetWorkoutSections,
    GetArticles,
    GetEvents,
    GetServices,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminLayout));
